<section class="content">
  <div class="row">
    <div class="col-lg-3">
      <div class="card card-body shadow-sm bg-info info-box">
        <div class="inner">
          <h3>{{ numberOfFreshWaters }}</h3>
          <p>Deliverys</p>
        </div>
        <div class="icon">
          <i class="icon icon-bag"></i>
        </div>
      </div>
    </div>
    <div class="col-lg-3">
      <div class="card card-body shadow-sm bg-info info-box">
        <div class="inner">
          <h3>{{ numberOfReceivingLocations }}</h3>
          <p>Receiving Location</p>
        </div>
        <div class="icon">
          <i class="icon icon-bag"></i>
        </div>
      </div>
    </div>
    <div class="col-lg-3">
      <div class="card card-body shadow-sm bg-info info-box">
        <div class="inner">
          <h3>{{ numberOfSuppliers }}</h3>
          <p>Suppliers</p>
        </div>
        <div class="icon">
          <i class="icon icon-bag"></i>
        </div>
      </div>
    </div>
    <div class="col-lg-3">
      <div class="card card-body shadow-sm bg-info info-box">
        <div class="inner">
          <h3 class="text-truncate">
            {{
              organisations?.get(biggestSupplierOrganisationId)
                ?.nameTranslations["en"]
            }}
          </h3>
          <p>Supplied {{ biggestSupplierProvidedTonnage | number }} tons</p>
        </div>
        <div class="icon">
          <i class="icon icon-bag"></i>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="col-md-12 col-xs-12 vh-100">
        <ag-grid-angular
        class="ag-theme-alpine"
        [gridOptions]="gridOptions"
        (gridReady)="gridSetting($event)"
        (paginationChanged)="saveGridState($event)"
        (sortChanged)="saveGridState($event)"
        (firstDataRendered)="restoreGridState($event)"
        [columnDefs]="columnDefs"
        [rowData]="freshWatersDeliveryNote"
        [domLayout]="'autoHeight'"
        [pagination]= "true"
        [paginationPageSize]="10"
        [paginationPageSizeSelector]="[10,20,30]"
        [enableCellTextSelection]="true"

        >
        </ag-grid-angular>
      </div>
    </div>
  </div>
</section>
